module.exports = __webpack_public_path__ + "static/img/Paris-La-Defense-Arena.f7a372f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paris-La-Defense-Arena.jpg
// module id = F9UU
// module chunks = 0